import Heading from "./Heading";
import { useState } from "react";

import { Link, useLocation } from "react-router-dom";
import format from "date-fns/format";
import ID from "date-fns/locale/id";

import { ReactComponent as Logo } from "assets/images/logo.svg";

import ListMenu, { TMenu } from "components/molecules/ListMenu";

import Button from "react-components/dist/components/Button";
import { useAppSelector, useAppDispatch } from "lib/store/hooks";
import { toggleSidebar, forceHideSidebar } from "lib/store/slices/components";

import modal from "react-components/dist/components/Modal";
import ModalProfile from "../ModalProfile";
import {
  ArrowLeft,
  CalendarBlank,
  ClockCounterClockwise,
  // Crown,
  FileXls,
  Gear,
  Heart,
  List,
  Plug,
  SealCheck,
  ShoppingCartSimple,
  SquaresFour,
  Stack,
  // Swap,
  User,
} from "@phosphor-icons/react";
import Notifikasi from "../Notifikasi";

import packageJson from "../../../../package.json";
import useMediaQuery from "lib/helpers/useMediaQuery";
import Spinner from "react-components/dist/components/Spinner";

// import { useFlag, useVariant } from "@unleash/proxy-client-react";
import HelpButton from "./HelpButton";
// import useQueryParams from "lib/helpers/useQueryParams";

import ContextMenuLockMainMenu from "./ContextMenuLockMainMenu";
import ContextMenuMejadokter from "./ContextMenuMejadokter";
import Kiosk from "./Kiosk";
import Pill from "react-components/dist/components/Pill";

// interface Props {}

const CONFIGS = {
  hasServices: true,
  hasNotificationTab: false,
  hasKioskTab: false,
  collapsePOSTab: true,
};

const useMenus = () => {
  const { selected } = useAppSelector((state) => state.clinics);
  const users = useAppSelector((state) => state.users);
  const services = useAppSelector((state) => state.services);
  const calendars = useAppSelector((state) => state.calendars);

  // const query = useQueryParams();

  const crmConnectedMenu =
    !!selected &&
    !!Object.hasOwn(selected, "metaDataCrm") &&
    !!selected?.metaDataCrm?.crmEnabled
      ? {
          overview: {
            title: "Ringkasan",
            slug: `/clinics/${selected?._id}/integrations/crm/overview`,
            end: true,
          },
          logs: {
            title: "Riwayat",
            slug: `/clinics/${selected?._id}/integrations/crm/logs`,
            end: true,
          },
          "marketing-campaign": {
            title: "Pemasaran",
            slug: `/clinics/${selected?._id}/integrations/crm/marketing-campaign`,
            end: true,
          },
          communication: {
            title: "Komunikasi",
            slug: `/clinics/${selected?._id}/integrations/crm/communication`,
            end: true,
          },
          // feedback: {
          //   title: "Kritik dan Saran",
          //   slug: `/clinics/${selected?._id}/integrations/crm/feedback`,
          //   end: true,
          // },
          // survey: {
          //   title: (
          //     <span className="inline-flex gap-x-1">
          //       Survei <Crown size={18} className="fill-yellow-700" />
          //     </span>
          //   ),
          //   slug: `/clinics/${selected?._id}/integrations/crm/survey`,
          //   end: true,
          // },
          // chatbot: {
          //   title: (
          //     <span className="inline-flex gap-x-1">
          //       Chatbot <Crown size={18} className="fill-yellow-700" />
          //     </span>
          //   ),
          //   slug: `/clinics/${selected?._id}/integrations/crm/chatbot`,
          //   end: true,
          // },
          // loyalty: {
          //   title: (
          //     <span className="inline-flex gap-x-1">
          //       Poin loyalti <Crown size={18} className="fill-yellow-700" />
          //     </span>
          //   ),
          //   slug: `/clinics/${selected?._id}/integrations/crm/loyalty`,
          //   end: true,
          // },
          // omnichannel: {
          //   title: (
          //     <span className="inline-flex gap-x-1">
          //       Omnichannel <Crown size={18} className="fill-yellow-700" />
          //     </span>
          //   ),
          //   slug: `/clinics/${selected?._id}/integrations/crm/omnichannel`,
          //   end: true,
          // },
          // segmentation: {
          //   title: (
          //     <span className="inline-flex gap-x-1">
          //       Segmentasi
          //       <Crown size={18} className="fill-yellow-700" />
          //     </span>
          //   ),
          //   slug: `/clinics/${selected?._id}/integrations/crm/segmentation`,
          //   end: true,
          // },
        }
      : undefined;

  const menus: {
    [key: string]: TMenu;
  } = {
    dashboard: {
      title: "Dashboard",
      icon: <SquaresFour size={22} />,
      slug: `/clinics/${selected?._id}/dashboard`,
    },
    calendars: {
      hasAccess:
        users.profile?.entity === "owner" ||
        !!users.profile?.authority?.appointment,
      title: "Kalender",
      icon: (
        <span className="relative">
          <CalendarBlank size={22} />
          <span className="absolute inset-0 flex w-full items-center justify-center pt-1 text-[8px] font-bold">
            {new Date().getDate()}
          </span>
          <span className="absolute -bottom-[14px] flex w-full items-center justify-center pt-1 text-[9px] font-bold tracking-wider">
            {format(new Date(), "MMM", { locale: ID })}
          </span>
        </span>
      ),
      slug: `/clinics/${selected?._id}/calendars`,
      badge: calendars.count,
    },
    services: {
      hasAccess:
        users.profile?.entity === "owner" ||
        [
          users.profile?.authority?.service?.["list-patient"],
          users.profile?.authority?.service?.["nursing-care"],
          !!users.profile?.authority?.service?.["medical-record"],
          !!users.profile?.authority?.service?.["medical-record"]?.treatment,
          !!users.profile?.authority?.service?.["medical-record"]?.history,
          users.profile?.authority?.service?.["laboratorium"],
          users.profile?.authority?.service?.["pharmacy-transactions"],
        ].some((item) => item),
      title: "Pelayanan",
      icon: <Heart size={22} />,
      slug: `/clinics/${selected?._id}/services`,
      isAnchor: true,
      child: {
        "rawat-inap": {
          hasAccess:
            !!selected?.hasRanap &&
            (users.profile?.entity === "owner" ||
              [
                users.profile?.authority?.service?.["list-patient"],
                users.profile?.authority?.service?.["nursing-care"],
                !!users.profile?.authority?.service?.["medical-record"],
                !!users.profile?.authority?.service?.["medical-record"]
                  ?.treatment,
                !!users.profile?.authority?.service?.["medical-record"]
                  ?.history,
              ].some((item) => item)),
          // isUnderconstruction: process.env.REACT_APP_STAGING !== "dev",
          title: "Menginap",
          slug: `/clinics/${selected?._id}/services/rawat-inap`,
          badge: services.states["rawat-inap"],
        },
      },
    },
    pos: {
      hasPulse: services.states["waiting"] > 0,
      hasAccess:
        users.profile?.entity === "owner" ||
        [
          users.profile?.authority?.pos?.create,
          users.profile?.authority?.pos?.logs,
        ].some((item) => item),
      title: "Point of Sales",
      icon: <ShoppingCartSimple size={22} />,
      slug: `/clinics/${selected?._id}/pos`,
      isAnchor: true,
      child: {
        transactions: {
          hasAccess:
            users.profile?.entity === "owner" ||
            [users.profile?.authority?.pos?.create].some((item) => item),
          title: "Kasir",
          slug: `/clinics/${selected?._id}/pos/transactions`,
        },
        waiting: {
          isHidden: !selected?.hasRanap || !CONFIGS.hasServices,
          hasAccess:
            users.profile?.entity === "owner" ||
            [users.profile?.authority?.pos?.create].some((item) => item),
          title: "Menunggu Pembayaran",
          slug: `/clinics/${selected?._id}/pos/waiting`,
          badge: services.states["waiting"],
        },
        logs: {
          hasAccess:
            users.profile?.entity === "owner" ||
            [users.profile?.authority?.pos?.logs].some((item) => item),
          title: "Riwayat",
          slug: `/clinics/${selected?._id}/pos/logs`,
        },
      },
    },
    manages: {
      hasAccess:
        users.profile?.entity === "owner" ||
        [
          users.profile?.authority?.manage?.doctor,
          users.profile?.authority?.manage?.nurse,
          users.profile?.authority?.manage?.staff,
          users.profile?.authority?.manage?.patient,
          users.profile?.authority?.manage?.iks,
          users.profile?.authority?.manage?.["rumah-sakit"],
          users.profile?.authority?.manage?.["polies"],
          users.profile?.authority?.manage?.products,
          users.profile?.authority?.manage?.units,
          users.profile?.authority?.manage?.["product-categories"],
          users.profile?.authority?.manage?.["documents"],
        ].some((item) => item),
      title: "Manajemen Data",
      icon: <Stack size={22} />,
      slug: `/clinics/${selected?._id}/manages`,
      isAnchor: true,
      child: {
        employees: {
          hasAccess:
            users.profile?.entity === "owner" ||
            [
              users.profile?.authority?.manage?.doctor,
              users.profile?.authority?.manage?.nurse,
              users.profile?.authority?.manage?.staff,
            ].some((item) => item),
          title: "Kepegawaian",
          slug: `/clinics/${selected?._id}/manages/employees`,
        },
        patients: {
          isUnderconstruction: !CONFIGS.hasServices,
          hasAccess:
            users.profile?.entity === "owner" ||
            [users.profile?.authority?.manage?.patient].some((item) => item),
          title: "Member",
          slug: `/clinics/${selected?._id}/manages/patients`,
        },
        iks: {
          isUnderconstruction: !CONFIGS.hasServices,
          hasAccess:
            users.profile?.entity === "owner" ||
            !!users.profile?.authority?.manage?.iks,
          title: "Tipe Member",
          slug: `/clinics/${selected?._id}/manages/iks`,
        },
        // polies: {
        //   isUnderconstruction: !CONFIGS.hasServices,
        //   hasAccess:
        //     users.profile?.entity === "owner" ||
        //     [users.profile?.authority?.manage?.["polies"]].some((item) => item),
        //   title: "Poli",
        //   slug: `/clinics/${selected?._id}/manages/polies`,
        // },
        inpatients: {
          // isUnderconstruction: !CONFIGS.hasServices,
          hasAccess:
            !!selected?.hasRanap &&
            (users.profile?.entity === "owner" ||
              [users.profile?.authority?.manage?.inpatients].some(
                (item) => item
              )),
          title: "Ruang Pos",
          slug: `/clinics/${selected?._id}/manages/inpatients`,
        },
        products: {
          hasAccess:
            users.profile?.entity === "owner" ||
            [users.profile?.authority?.manage?.products].some((item) => item),
          // hrefOldApp: `${
          //   process.env.REACT_APP_HOST_OLD || "https://app.mejadokter.com"
          // }/login?root=1&token=${users.token}&path=/manage/products`,
          title: "Produk",
          slug: `/clinics/${selected?._id}/manages/products`,
          // child: {
          //   "purchase-order": {
          //     title: "Purchase order",
          //     slug: `/clinics/${selected?._id}/manages/products/purchase-order`,
          //   },
          // },
        },
        suppliers: {
          hasAccess:
            users.profile?.entity === "owner" ||
            [users.profile?.authority?.manage?.suppliers].some((item) => item),
          // hrefOldApp: `${
          //   process.env.REACT_APP_HOST_OLD || "https://app.mejadokter.com"
          // }/login?root=1&token=${users.token}&path=/manage/products`,
          title: "Suplier",
          slug: `/clinics/${selected?._id}/manages/suppliers`,
          // child: {
          //   "purchase-order": {
          //     title: "Purchase order",
          //     slug: `/clinics/${selected?._id}/manages/suppliers/purchase-order`,
          //   },
          // },
        },
        // documents: {
        //   isUnderconstruction: !CONFIGS.hasServices,
        //   title: "Dokumen",
        //   slug: `/clinics/${selected?._id}/manages/documents`,
        // },
        // diagnoses: {
        //   isUnderconstruction: process.env.REACT_APP_STAGING !== "dev",
        //   title: "Diagnosa",
        //   slug: `/clinics/${selected?._id}/manages/diagnoses`,
        // },
      },
    },
    reports: {
      hasAccess:
        users.profile?.entity === "owner" ||
        [
          users.profile?.authority?.reports?.apotek,
          users.profile?.authority?.reports?.services,
          users.profile?.authority?.reports?.sales,
          users.profile?.authority?.reports?.administrasi,
          users.profile?.authority?.reports?.tindakan,
        ].some((item) => item),
      title: "Laporan",
      icon: <FileXls size={22} />,
      slug: `/clinics/${selected?._id}/reports`,
      isAnchor: true,
      child: {
        services: {
          isHidden: true,
          hasAccess:
            users.profile?.entity === "owner" ||
            !!users.profile?.authority?.reports?.["services"],
          title: "Pelayanan",
          slug: `/clinics/${selected?._id}/reports/services`,
          isAnchor: true,
          isUnderconstruction: !CONFIGS.hasServices,
          child: {
            "rawat-jalan": {
              isHidden: true,
              hasAccess:
                users.profile?.entity === "owner" ||
                users.profile?.authority?.reports?.services ||
                users.profile?.authority?.reports?.services?.["rawat-jalan"],
              title: "Rawat Jalan",
              slug: `/clinics/${selected?._id}/reports/services/rawat-jalan`,
              isAnchor: true,
              child: {
                overview: {
                  title: "Ringkasan",
                  slug: `/clinics/${selected?._id}/reports/services/rawat-jalan/overview`,
                },
                kunjungan: {
                  title: "Kunjungan",
                  slug: `/clinics/${selected?._id}/reports/services/rawat-jalan/kunjungan`,
                },
              },
            },
            "rawat-inap": {
              isUnderconstruction: process.env.REACT_APP_STAGING !== "dev",
              hasAccess:
                users.profile?.entity === "owner" ||
                users.profile?.authority?.reports?.services ||
                users.profile?.authority?.reports?.services?.["rawat-inap"],
              title: "Rawat Inap",
              slug: `/clinics/${selected?._id}/reports/services/rawat-inap`,
            },
            ugd: {
              isHidden: true,
              hasAccess:
                users.profile?.entity === "owner" ||
                users.profile?.authority?.reports?.services ||
                users.profile?.authority?.reports?.services?.["ugd"],
              title: "UGD",
              slug: `/clinics/${selected?._id}/reports/services/ugd`,
              isAnchor: true,
              child: {
                overview: {
                  title: "Ringkasan",
                  slug: `/clinics/${selected?._id}/reports/services/ugd/overview`,
                },
                kunjungan: {
                  title: "Kunjungan",
                  slug: `/clinics/${selected?._id}/reports/services/ugd/kunjungan`,
                },
              },
            },
            oncall: {
              isHidden: true,
              hasAccess:
                users.profile?.entity === "owner" ||
                users.profile?.authority?.reports?.services ||
                users.profile?.authority?.reports?.services?.["oncall"],
              title: "On Call",
              slug: `/clinics/${selected?._id}/reports/services/oncall`,
              isAnchor: true,
              child: {
                overview: {
                  title: "Ringkasan",
                  slug: `/clinics/${selected?._id}/reports/services/oncall/overview`,
                },
                kunjungan: {
                  title: "Kunjungan",
                  slug: `/clinics/${selected?._id}/reports/services/oncall/kunjungan`,
                },
              },
            },
            laboratorium: {
              isHidden: true,
              isUnderconstruction: process.env.REACT_APP_STAGING !== "dev",
              hasAccess:
                users.profile?.entity === "owner" ||
                users.profile?.authority?.reports?.services ||
                users.profile?.authority?.reports?.services?.["laboratorium"],
              title: "Laboratorium",
              slug: `/clinics/${selected?._id}/reports/services/laboratorium`,
            },
            radiologi: {
              isHidden: true,
              isUnderconstruction: process.env.REACT_APP_STAGING !== "dev",
              hasAccess:
                users.profile?.entity === "owner" ||
                users.profile?.authority?.reports?.services ||
                users.profile?.authority?.reports?.services?.["radiologi"],
              title: "Radiologi",
              slug: `/clinics/${selected?._id}/reports/services/radiologi`,
            },
          },
        },
        sales: {
          hasAccess:
            users.profile?.entity === "owner" ||
            !!users.profile?.authority?.reports?.sales,
          title: "Penjualan",
          slug: `/clinics/${selected?._id}/reports/sales`,
          isAnchor: true,
          child: {
            "rawat-jalan": {
              isHidden: true,
              hasAccess:
                users.profile?.entity === "owner" ||
                users.profile?.authority?.reports?.sales ||
                users.profile?.authority?.reports?.sales?.["rawat-jalan"],
              title: "Rawat Jalan",
              slug: `/clinics/${selected?._id}/reports/sales/rawat-jalan`,
              isUnderconstruction: !CONFIGS.hasServices,
              isAnchor: true,
              child: {
                overview: {
                  title: "Ringkasan",
                  slug: `/clinics/${selected?._id}/reports/sales/rawat-jalan/overview`,
                },
                details: {
                  title: "Terinci",
                  slug: `/clinics/${selected?._id}/reports/sales/rawat-jalan/details`,
                },
                // tindakan: {
                //   title: "Tindakan",
                //   slug: `/clinics/${selected?._id}/reports/sales/rawat-jalan/tindakan`,
                // },
              },
            },
            "rawat-inap": {
              // isUnderconstruction: process.env.REACT_APP_STAGING !== "dev",
              hasAccess:
                users.profile?.entity === "owner" ||
                users.profile?.authority?.reports?.sales ||
                users.profile?.authority?.reports?.sales?.["rawat-inap"],
              title: "Menginap",
              slug: `/clinics/${selected?._id}/reports/sales/rawat-inap`,
              isUnderconstruction: !CONFIGS.hasServices,
              isAnchor: true,
              child: {
                overview: {
                  title: "Ringkasan",
                  slug: `/clinics/${selected?._id}/reports/sales/rawat-inap/overview`,
                },
                details: {
                  title: "Terinci",
                  slug: `/clinics/${selected?._id}/reports/sales/rawat-inap/details`,
                },
                // tindakan: {
                //   title: "Tindakan",
                //   slug: `/clinics/${selected?._id}/reports/sales/rawat-jalan/tindakan`,
                // },
              },
            },
            ugd: {
              isHidden: true,
              hasAccess:
                users.profile?.entity === "owner" ||
                users.profile?.authority?.reports?.sales ||
                users.profile?.authority?.reports?.sales?.["ugd"],
              title: "UGD",
              slug: `/clinics/${selected?._id}/reports/sales/ugd`,
              isUnderconstruction: !CONFIGS.hasServices,
              isAnchor: true,
              child: {
                overview: {
                  title: "Ringkasan",
                  slug: `/clinics/${selected?._id}/reports/sales/ugd/overview`,
                },
                details: {
                  title: "Terinci",
                  slug: `/clinics/${selected?._id}/reports/sales/ugd/details`,
                },
              },
            },
            oncall: {
              isHidden: true,
              hasAccess:
                users.profile?.entity === "owner" ||
                users.profile?.authority?.reports?.sales ||
                users.profile?.authority?.reports?.sales?.["oncall"],
              title: "On Call",
              slug: `/clinics/${selected?._id}/reports/sales/oncall`,
              isUnderconstruction: !CONFIGS.hasServices,
              isAnchor: true,
              child: {
                overview: {
                  title: "Ringkasan",
                  slug: `/clinics/${selected?._id}/reports/sales/oncall/overview`,
                },
                details: {
                  title: "Terinci",
                  slug: `/clinics/${selected?._id}/reports/sales/oncall/details`,
                },
              },
            },
            laboratorium: {
              isHidden: true,
              isUnderconstruction: !CONFIGS.hasServices,
              hasAccess:
                users.profile?.entity === "owner" ||
                users.profile?.authority?.reports?.sales ||
                users.profile?.authority?.reports?.sales?.["laboratorium"],
              title: "Laboratorium",
              slug: `/clinics/${selected?._id}/reports/sales/laboratorium`,
            },
            radiologi: {
              isHidden: true,
              isUnderconstruction: !CONFIGS.hasServices,
              hasAccess:
                users.profile?.entity === "owner" ||
                users.profile?.authority?.reports?.sales ||
                users.profile?.authority?.reports?.sales?.["radiologi"],
              title: "Radiologi",
              slug: `/clinics/${selected?._id}/reports/sales/radiologi`,
            },
            pos: {
              hasAccess:
                users.profile?.entity === "owner" ||
                users.profile?.authority?.reports?.sales,
              title: "Penjualan Langsung",
              slug: `/clinics/${selected?._id}/reports/sales/pos`,
              isAnchor: true,
              child: {
                overview: {
                  title: "Ringkasan",
                  slug: `/clinics/${selected?._id}/reports/sales/pos/overview`,
                },
                details: {
                  title: "Terinci",
                  slug: `/clinics/${selected?._id}/reports/sales/pos/details`,
                },
              },
            },
          },
        },
        administrasi: {
          isHidden: true,
          hasAccess:
            users.profile?.entity === "owner" ||
            users.profile?.authority?.reports?.administrasi,
          title: "Penerbitan Surat",
          slug: `/clinics/${selected?._id}/reports/administrasi`,
        },
        "bagi-hasil-tindakan": {
          isHidden: true,
          hasAccess:
            users.profile?.entity === "owner" ||
            !!users.profile?.authority?.reports?.["tindakan"],
          title: "Bagi Hasil",
          slug: `/clinics/${selected?._id}/reports/bagi-hasil-tindakan`,
        },
        apotek: {
          hasAccess:
            users.profile?.entity === "owner" ||
            !!users.profile?.authority?.reports?.apotek,
          title: "Barang",
          slug: `/clinics/${selected?._id}/reports/apotek`,
          child: {
            overview: {
              title: "Ringkasan",
              slug: `/clinics/${selected?._id}/reports/apotek/overview`,
            },
            logs: {
              title: "Riwayat",
              slug: `/clinics/${selected?._id}/reports/apotek/logs`,
            },
            "drugs-condition": {
              title: "Kondisi Stok",
              slug: `/clinics/${selected?._id}/reports/apotek/drugs-condition`,
            },
            puyer: {
              isHidden: true,
              title: "Puyer",
              slug: `/clinics/${selected?._id}/reports/apotek/puyer`,
            },
          },
        },
      },
    },
    settings: {
      hasAccess:
        users.profile?.entity === "owner" ||
        [
          users.profile?.authority?.settings?.general,
          users.profile?.authority?.settings?.logo,
          users.profile?.authority?.settings?.bpjs,
          users.profile?.authority?.settings?.["rawat-inap"],
          users.profile?.authority?.settings?.["rawat-jalan"],
          users.profile?.authority?.settings?.["hak-kewajiban-pasien"],
          users.profile?.authority?.settings?.["instalasi-farmasi"],
          users.profile?.authority?.settings?.["coding-rm"],
          users.profile?.authority?.settings?.["point-of-sales"],
          users.profile?.authority?.settings?.["calendars"],
          users.profile?.authority?.settings?.["kiosk"],
          users.profile?.authority?.settings?.["announcers"],
          users.profile?.authority?.settings?.["kegawat-daruratan"],
          users.profile?.authority?.settings?.["oncall"],
          // users.profile?.authority?.settings?.["notifications"],
        ].some((item) => item),
      title: "Pengaturan",
      icon: <Gear size={22} />,
      slug: `/clinics/${selected?._id}/settings`,
      isAnchor: true,
      child: {
        general: {
          hasAccess:
            users.profile?.entity === "owner" ||
            users.profile?.authority?.settings?.general,
          title: "Informasi Umum",
          slug: `/clinics/${selected?._id}/settings/general`,
          end: true,
        },
        logo: {
          hasAccess:
            users.profile?.entity === "owner" ||
            users.profile?.authority?.settings?.logo,
          title: "Logo",
          slug: `/clinics/${selected?._id}/settings/logo`,
          end: true,
        },
        // "instalasi-farmasi": {
        //   isUnderconstruction: !CONFIGS.hasServices,
        //   hasAccess:
        //     users.profile?.entity === "owner" ||
        //     users.profile?.authority?.settings?.["instalasi-farmasi"],
        //   title: "Instalasi Farmasi",
        //   slug: `/clinics/${selected?._id}/settings/instalasi-farmasi`,
        //   end: true,
        // },
        // "coding-rm": {
        //   isUnderconstruction: !CONFIGS.hasServices,
        //   hasAccess:
        //     users.profile?.entity === "owner" ||
        //     users.profile?.authority?.settings?.["coding-rm"],
        //   title: "Koding RM",
        //   slug: `/clinics/${selected?._id}/settings/coding-rm`,
        //   end: true,
        // },
        "point-of-sales": {
          hasAccess:
            users.profile?.entity === "owner" ||
            users.profile?.authority?.settings?.["point-of-sales"],
          title: "Point-of-sales",
          slug: `/clinics/${selected?._id}/settings/point-of-sales`,
          end: true,
        },
        "rawat-inap": {
          // isUnderconstruction: !CONFIGS.hasServices,
          hasAccess:
            users.profile?.entity === "owner" ||
            users.profile?.authority?.settings?.["rawat-inap"],
          title: "Pelayanan / Menginap",
          slug: `/clinics/${selected?._id}/settings/rawat-inap`,
          end: true,
        },
        // "rawat-jalan": {
        //   hasAccess:
        //     users.profile?.entity === "owner" ||
        //     users.profile?.authority?.settings?.["rawat-jalan"],
        //   title: "Rawat Jalan",
        //   slug: `/clinics/${selected?._id}/settings/rawat-jalan`,
        //   end: true,
        // },
        // "hak-kewajiban-pasien": {
        //   isUnderconstruction: !CONFIGS.hasServices,
        //   hasAccess:
        //     users.profile?.entity === "owner" ||
        //     users.profile?.authority?.settings?.["hak-kewajiban-pasien"],
        //   title: "Hak & Kewajiban Pasien",
        //   slug: `/clinics/${selected?._id}/settings/hak-kewajiban-pasien`,
        //   end: true,
        // },
        calendars: {
          hasAccess:
            users.profile?.entity === "owner" ||
            users.profile?.authority?.settings?.["calendars"],
          title: "Kalender",
          slug: `/clinics/${selected?._id}/settings/calendars`,
          end: true,
        },
        kiosk: {
          isUnderconstruction: !CONFIGS.hasServices,
          hasAccess:
            users.profile?.entity === "owner" ||
            users.profile?.authority?.settings?.["kiosk"],
          title: "Kiosk",
          slug: `/clinics/${selected?._id}/settings/kiosk`,
          end: true,
        },
        announcers: {
          isUnderconstruction: !CONFIGS.hasServices,
          hasAccess:
            users.profile?.entity === "owner" ||
            users.profile?.authority?.settings?.["announcers"],
          title: "Announcers",
          slug: `/clinics/${selected?._id}/settings/announcers`,
          end: true,
        },
      },
    },
    integrations: {
      isAnchor: true,
      title: "Modul & Integrasi",
      icon: <Plug size={22} />,
      slug: `/clinics/${selected?._id}/integrations`,
      child: {
        // bpjs: {
        //   title: "BPJS",
        //   slug: `/clinics/${selected?._id}/integrations/bpjs`,
        //   child: bpjsConnectedMenu,
        //   isAnchor: true,
        // },
        crm: {
          title: (
            <span className="relative flex flex-col items-start">
              <span className="">Hubungan Pelanggan</span>
              <Pill size="xs" state="info">
                CRM
              </Pill>
            </span>
          ),
          slug: `/clinics/${selected?._id}/integrations/crm`,
          child: crmConnectedMenu,
        },
        "landing-page": {
          title: "Landing Page",
          slug: `/clinics/${selected?._id}/integrations/landing-page`,
        },
        // satusehat: {
        //   title: (
        //     <span className="relative flex flex-col items-start">
        //       <span className="">Satu Sehat</span>
        //       <Pill size="xs" state="info">
        //         by Kemenkes
        //       </Pill>
        //     </span>
        //   ),
        //   slug: `/clinics/${selected?._id}/integrations/satusehat`,
        // },
      },
    },
    histories: {
      hasAccess:
        users.profile?.entity === "owner" ||
        [users.profile?.authority?.histories].some((item) => item),
      end: true,
      title: "Riwayat Penggunaan",
      icon: <ClockCounterClockwise size={22} />,
      slug: `/clinics/${selected?._id}/histories`,
    },
  };

  if (!CONFIGS.hasServices || !selected?.hasRanap) {
    delete menus.services;
    if (
      menus.reports.child &&
      menus.reports.child.sales &&
      menus.reports.child.sales.child &&
      menus.reports.child.sales.child["rawat-inap"]
    )
      delete menus.reports.child.sales.child["rawat-inap"];
  }

  if (!selected?.metaData?.hasCalendar) {
    delete menus.calendars;
  }

  return menus;
};

const Sidebar = () => {
  const [isLoadingSelectingClinic, isLoadingSelectingClinicSet] =
    useState(false);

  const { sidebar } = useAppSelector((state) => state.components);
  const { selected } = useAppSelector((state) => state.clinics);
  const users = useAppSelector((state) => state.users);
  const services = useAppSelector((state) => state.services);

  const isMobile = useMediaQuery("(max-width: 767px)");

  const dispatch = useAppDispatch();

  const location = useLocation();

  const menus = useMenus();

  function fnModalProfile() {
    modal.show(
      <ModalProfile
        isLoadingSelectingClinicSet={isLoadingSelectingClinicSet}
      />,
      {
        close: {
          outsideClick: true,
          closeOnEscape: true,
          display: false,
        },
        container: {
          className: "flex justify-start min-h-screen",
        },
        overlay: {
          overrideClassName: "overflow-x-hidden",
        },
        wrapper: {
          className:
            "min-h-screen bg-white dark:bg-gray-900 h-full w-[320px] relative bg-white transition-all duration-300",
          timeout: 300,
          animatedClassNames: {
            appear: "-left-full opacity-0",
            appearActive: "-left-full opacity-0",
            appearDone: "opacity-100 left-0",
            enter: "-left-full opacity-100",
            enterActive: "-left-full opacity-100",
            enterDone: "left-0 opacity-100",
            exit: "left-0",
            exitActive: "-left-full opacity-0",
            exitDone: "-left-full opacity-0",
          },
        },
      }
    );
  }

  function onContextMenuLockSidebar(e: any) {
    e.preventDefault();

    modal.show(<ContextMenuLockMainMenu />, {
      close: {
        outsideClick: true,
        closeOnEscape: true,
        display: false,
      },
      container: {
        className: "",
      },
      overlay: {
        timeout: 0,
        // className: "absolute top-0 left-0",
        // overrideClassName: "bg-black/0",
        animatedClassNames: {
          appear: "opacity-0 bg-black/0",
          appearActive: "opacity-0 bg-black/0",
          appearDone: "opacity-100 bg-black/0",
          enter: "opacity-0 bg-black/0",
          enterActive: "opacity-0 bg-black/0",
          enterDone: "opacity-100 bg-black/0",
          exit: "",
          exitActive: "opacity-0 bg-black/0",
          exitDone: "opacity-0 bg-black/0",
        },
      },
      wrapper: {
        className:
          "bg-white dark:bg-gray-900 w-[220px] relative bg-white shadow-lg rounded",
        timeout: 0,
        style: {
          left: e.clientX,
          top: e.clientY,
        },
      },
    });
  }

  function onContextMenuMejadokter(e: any) {
    e.preventDefault();

    modal.show(<ContextMenuMejadokter />, {
      close: {
        outsideClick: true,
        closeOnEscape: true,
        display: false,
      },
      container: {
        className: "",
      },
      overlay: {
        timeout: 0,
        // className: "absolute top-0 left-0",
        // overrideClassName: "bg-black/0",
        animatedClassNames: {
          appear: "opacity-0 bg-black/0",
          appearActive: "opacity-0 bg-black/0",
          appearDone: "opacity-100 bg-black/0",
          enter: "opacity-0 bg-black/0",
          enterActive: "opacity-0 bg-black/0",
          enterDone: "opacity-100 bg-black/0",
          exit: "",
          exitActive: "opacity-0 bg-black/0",
          exitDone: "opacity-0 bg-black/0",
        },
      },
      wrapper: {
        className: "bg-white dark:bg-gray-900 w-[280px] relative",
        timeout: 0,
        style: {
          left: e.clientX,
          top: e.clientY,
        },
      },
    });
  }

  // const blackListToggleMenu = [
  //   "services/rekam-medis/",
  //   "services/laboratorium/",
  // ];

  return (
    <>
      {isLoadingSelectingClinic && (
        <div className="fixed inset-0 z-[999] flex items-center justify-center gap-x-4 bg-white/95 backdrop-blur-sm">
          <Spinner size="lg" /> Mempersiapkan faskes...
        </div>
      )}
      <div className="h-full lg:h-auto lg:w-auto lg:flex-auto">
        <div
          className={[
            "fixed top-0 z-50 flex transition-all duration-300",
            sidebar.isActive ? "left-0" : "-left-full lg:left-0",
          ].join(" ")}
        >
          <aside className="relative z-50 flex h-screen w-16 flex-col items-center justify-between shadow-sm dark:shadow-gray-700 bg-blue-900 dark:bg-gray-950">
            {selected && (
              <>
                <div className="group relative my-4 flex">
                  <Button
                    ripple
                    className="w-10 justify-center rounded-full bg-white"
                    state="custom"
                  >
                    <Link to={`/clinics/${selected._id}`}>
                      <img
                        src={selected.logo}
                        className="aspect-square object-cover"
                        alt={selected.name}
                      />
                    </Link>
                  </Button>
                  <span className="pointer-events-none absolute left-0 top-1/2 z-50 ml-2 flex -translate-y-1/2 transform select-none whitespace-nowrap bg-black/75 px-2 py-1 text-sm text-white opacity-0 transition-all group-hover:left-full group-hover:opacity-100">
                    {selected.name}{" "}
                    {!!selected.branch &&
                      selected.branch !== "" &&
                      `(${selected.branch})`}
                  </span>
                </div>
              </>
            )}

            {selected && location.pathname.includes("/clinics/") && (
              <div className="flex flex-col gap-y-2">
                {isMobile ? (
                  <div className="group relative">
                    <Button
                      ripple
                      className="w-10 justify-center rounded-full bg-blue-800 text-white dark:bg-gray-900"
                      state="custom"
                    >
                      <button onClick={() => dispatch(toggleSidebar(false))}>
                        <ArrowLeft size={22} />
                      </button>
                    </Button>
                    <span className="pointer-events-none absolute left-0 top-1/2 z-50 ml-2 flex -translate-y-1/2 transform select-none whitespace-nowrap bg-black/75 px-2 py-1 text-sm text-white opacity-0 transition-all group-hover:left-full group-hover:opacity-100">
                      {!sidebar.isForceHidden
                        ? "Sembunyikan Menu"
                        : "Munculkan Menu"}
                    </span>
                  </div>
                ) : (
                  <div className="group relative">
                    <Button
                      ripple
                      className="w-10 justify-center rounded-full bg-blue-800 text-white dark:bg-gray-900"
                      state="custom"
                    >
                      <button
                        onClick={() =>
                          dispatch(forceHideSidebar(!sidebar.isForceHidden))
                        }
                        onContextMenu={onContextMenuLockSidebar}
                      >
                        <List size={22} />
                      </button>
                    </Button>
                    <span className="pointer-events-none absolute left-0 top-1/2 z-50 ml-2 flex -translate-y-1/2 transform select-none whitespace-nowrap bg-black/75 px-2 py-1 text-sm text-white opacity-0 transition-all group-hover:left-full group-hover:opacity-100">
                      {!sidebar.isForceHidden
                        ? "Sembunyikan Menu"
                        : "Munculkan Menu"}
                    </span>
                  </div>
                )}

                {(users.profile?.entity === "owner" ||
                  [
                    users.profile?.authority?.pos?.create,
                    users.profile?.authority?.pos?.logs,
                  ].some((item) => item)) && (
                  <div
                    className={[
                      "-mx-1 flex flex-col gap-y-2 rounded-full p-1 transition-all duration-300",
                      CONFIGS.collapsePOSTab ||
                      location.pathname.includes("/pos")
                        ? "bg-blue-700 dark:bg-gray-800"
                        : "group hover:bg-blue-700 hover:dark:bg-gray-800",
                    ].join(" ")}
                  >
                    {(users.profile?.entity === "owner" ||
                      users.profile?.authority?.pos?.create) && (
                      <div className="group relative">
                        <Button
                          ripple
                          className="w-10 justify-center rounded-full bg-blue-800 text-white dark:bg-gray-900"
                          state="custom"
                        >
                          <Link
                            to={`/clinics/${selected._id}/pos`}
                            onClick={() => dispatch(toggleSidebar(false))}
                          >
                            <ShoppingCartSimple size={22} />
                          </Link>
                        </Button>
                        {!location.pathname.includes("/pos") &&
                          services.states["waiting"] > 0 && (
                            <span
                              style={{ right: 2, bottom: 2 }}
                              className="pointer-events-none absolute flex h-2 w-2 items-center justify-center rounded-full border
        border-white bg-yellow-700 text-xs font-bold text-blue-900"
                            ></span>
                          )}
                        {location.pathname.includes("/pos") &&
                          !(
                            location.pathname.includes("/logs") ||
                            location.pathname.includes("/waiting")
                          ) && (
                            <span className="absolute -right-4 top-1/2 z-50 h-6 w-1 -translate-x-1/2 -translate-y-1/2 transform rounded-full bg-yellow-700"></span>
                          )}
                        <span className="pointer-events-none absolute left-0 top-1/2 z-50 ml-2 flex -translate-y-1/2 transform select-none whitespace-nowrap bg-black/75 px-2 py-1 text-sm text-white opacity-0 transition-all group-hover:left-full group-hover:opacity-100">
                          Kasir
                        </span>
                      </div>
                    )}

                    {!!CONFIGS.hasServices && !!selected.hasRanap && (
                      <div
                        className={[
                          "group relative transition-all duration-300",
                          (users.profile?.entity === "owner" ||
                            users.profile?.authority?.pos?.create) &&
                          (CONFIGS.collapsePOSTab ||
                            location.pathname.includes("/pos"))
                            ? ""
                            : "hidden opacity-0 group-hover:block group-hover:opacity-100",
                        ].join(" ")}
                      >
                        <Button
                          ripple
                          className="w-10 justify-center rounded-full bg-blue-800 text-white dark:bg-gray-900"
                          state="custom"
                        >
                          <Link
                            to={`/clinics/${selected._id}/pos/waiting`}
                            onClick={() => {
                              dispatch(forceHideSidebar(false));
                              dispatch(toggleSidebar(false));
                            }}
                          >
                            <SealCheck size={22} />
                          </Link>
                        </Button>
                        {services.states["waiting"] > 0 && (
                          <span className="pointer-events-none absolute -bottom-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full border border-white bg-yellow-700 text-xxs font-bold text-blue-900">
                            {services.states["waiting"]}
                          </span>
                        )}
                        {location.pathname.includes("/waiting") && (
                          <span className="absolute -right-4 top-1/2 z-50 h-6 w-1 -translate-x-1/2 -translate-y-1/2 transform rounded-full bg-yellow-700"></span>
                        )}
                        <span className="pointer-events-none absolute left-0 top-1/2 z-50 ml-2 flex -translate-y-1/2 transform select-none whitespace-nowrap bg-black/75 px-2 py-1 text-sm text-white opacity-0 transition-all group-hover:left-full group-hover:opacity-100">
                          Menunggu Pembayaran
                        </span>
                      </div>
                    )}

                    <div
                      className={[
                        "group relative transition-all duration-300",
                        (users.profile?.entity === "owner" ||
                          users.profile?.authority?.pos?.create) &&
                        (CONFIGS.collapsePOSTab ||
                          location.pathname.includes("/pos"))
                          ? ""
                          : "hidden opacity-0 group-hover:block group-hover:opacity-100",
                      ].join(" ")}
                    >
                      <Button
                        ripple
                        className="w-10 justify-center rounded-full bg-blue-800 text-white dark:bg-gray-900"
                        state="custom"
                      >
                        <Link
                          to={`/clinics/${selected._id}/pos/logs`}
                          onClick={() => {
                            dispatch(forceHideSidebar(false));
                            dispatch(toggleSidebar(false));
                          }}
                        >
                          <ClockCounterClockwise size={22} />
                        </Link>
                      </Button>
                      {location.pathname.includes("/logs") && (
                        <span className="absolute -right-4 top-1/2 z-50 h-6 w-1 -translate-x-1/2 -translate-y-1/2 transform rounded-full bg-yellow-700"></span>
                      )}
                      <span className="pointer-events-none absolute left-0 top-1/2 z-50 ml-2 flex -translate-y-1/2 transform select-none whitespace-nowrap bg-black/75 px-2 py-1 text-sm text-white opacity-0 transition-all group-hover:left-full group-hover:opacity-100">
                        Riwayat Transaksi
                      </span>
                    </div>
                  </div>
                )}

                {!!CONFIGS.hasNotificationTab && <Notifikasi />}

                {!!CONFIGS.hasKioskTab && <Kiosk />}
              </div>
            )}

            <div className="mb-auto"></div>

            <div className="flex flex-col gap-y-2 text-white">
              <div className="group relative">
                <Button
                  ripple
                  className="w-10 justify-center rounded-full bg-blue-800 text-white dark:bg-gray-900 "
                  state="custom"
                >
                  <button id="modal-profile" onClick={fnModalProfile}>
                    <User size={22} />
                  </button>
                </Button>
                <span className="pointer-events-none absolute left-0 top-1/2 z-50 ml-2 flex -translate-y-1/2 transform select-none whitespace-nowrap bg-black/75 px-2 py-1 text-sm text-white opacity-0 transition-all group-hover:left-full group-hover:opacity-100">
                  Profil
                </span>
              </div>

              <hr className="my-1 opacity-10" />

              <HelpButton />

              <div className="relative mt-1 text-center">
                <div
                  className="flex h-10 w-10 items-center justify-center overflow-hidden rounded-full bg-success-300 cursor-pointer"
                  onContextMenu={onContextMenuMejadokter}
                >
                  <Logo width={22} className="logo-white" />
                </div>

                <span className="pointer-events-none text-xs text-white">
                  v{packageJson.version}
                </span>
              </div>
            </div>
          </aside>

          {selected &&
            location.pathname.includes("/clinics/") &&
            (!sidebar.isForceHidden || isMobile) && (
              <aside className="sidebar relative z-10 flex h-screen w-72 flex-col overflow-y-auto border-r border-gray-200 bg-gray-50 pb-32 shadow-sm shadow-gray-200 dark:shadow-gray-700 dark:border-gray-900 dark:bg-gray-925 dark:text-gray-50 ">
                <Heading />

                <ListMenu menus={menus} className="mt-4 px-4" />
              </aside>
            )}
        </div>

        {sidebar.isActive && (
          <div
            className="fixed inset-0 z-[31]"
            onClick={() => dispatch(toggleSidebar(false))}
          ></div>
        )}
      </div>

      <div className="hidden w-16 flex-none lg:table-cell"></div>
      {selected &&
        location.pathname.includes("/clinics/") &&
        !sidebar.isForceHidden && (
          <div className="hidden w-72 flex-none lg:table-cell"></div>
        )}
    </>
  );
};

export default Sidebar;
